<template>
	<nav>
		<div>
			<router-link 						
					v-for="page in parsedPages"
					:key="page.id"
					:to="`/`+page.slug" >
				{{page.title}}
				<span v-if="hasChildren(page)">
					<router-link 
							v-for="subPage in parsedSubPages(page)" 
							:key="subPage.id"
							:to="`/`+subPage.slug"
							v-text="subPage.title" />
				</span>
			</router-link>
		</div>
	</nav>
</template> 

<script>
import { pagesComputed } from '@/features/pages/store'
export default {	
	computed: {
		...pagesComputed,
		parsedPages() {
			return this.pages
				.filter(temp => temp.published && !temp.parentId)
				.sort((a,b) => a.position > b.position)
		}		
	},
	methods: {
		hasChildren(page) {
			return this.pages.filter(temp => temp.parentId == page.id).length > 0
		},
		parsedSubPages(page) {
			return this.pages
				.filter(temp => temp.published && temp.parentId == page.id)
				.sort((a,b) => a.position > b.position)
		}
	}
};
</script>

